export const UNKNOWN_LOCALIZATION_CONTENT = "?¿?¿?¿";
